import withProvider from "./with-provider";
export const wrapRootElement = withProvider;
